import React from 'react';
import { HeroSection } from '../components/landing/HeroSection';
import { WhyParticipateSection } from '../components/landing/WhyParticipateSection';
import { HowItWorksSection } from '../components/landing/HowItWorksSection';
import { KeyBenefitsSection } from '../components/landing/KeyBenefitsSection';
import { CommitmentsSection } from '../components/landing/CommitmentsSection';
import { TestimonialsSection } from '../components/landing/TestimonialsSection';
import { ApplicationFormSection } from '../components/landing/ApplicationFormSection';
import { AboutEediSection } from '../components/landing/AboutEediSection';
import { TeamSection } from '../components/landing/TeamSection';
import { PromoBanner } from '../components/landing/PromoBanner';
export function LandingPage() {
  return <div className="w-full" data-id="element-324">
      <HeroSection data-id="element-325" />
      <WhyParticipateSection data-id="element-326" />
      <HowItWorksSection data-id="element-327" />
      <KeyBenefitsSection data-id="element-328" />
      <CommitmentsSection data-id="element-329" />
      <AboutEediSection data-id="element-330" />
      <TeamSection data-id="element-331" />
      <TestimonialsSection data-id="element-332" />
      <ApplicationFormSection data-id="element-333" />
      <PromoBanner data-id="element-334" />
    </div>;
}